<!--课程学习-->
<template>
  <div class="xuexidongtai_layer">
    <div class="warp">
      <div class="l-warp">
        <div class="t-warp">
          <div class="l-img">
            <img src="~@imgs/curriculum/lefttop_bg.png" />
          </div>
          <div class="r-info">
            <div class="r-info-name">《AI金融课程》</div>
          </div>
        </div>
        <div class="b-warp listings-view">
          <dl class="item" v-for="(item, index) in dataList" :key="index">
            <dt>{{ item.chapterName }}</dt>
            <dd v-for="(o, i) in item.sectionList" :key="i">
              <span class="tag-pdf" v-if="o.coursewareType == 'pdf'">PDF</span>
              <span class="tag-video" v-else>视频</span>
              <span class="name-inner" :class="{ 'active': SectionId == o.sectionId }"
                    @click="handleFileOpen(item, o)">{{
                      o.sectionName }}</span>
              <span class="status-inner el-icon-success" v-if="o.statue" style="color:#009f43"></span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="r-warp">
        <!--视频-->
        <div v-if="resourcestype == 'mp4'" class="mp4">
          <video id="video" class="video" controls x5-video-player-type="h5-page" width="100%" height="100%"
                 style="object-fit: cover;">
            <!-- <source src="~@img/test.mp4" type="video/mp4" /> -->
          </video>
        </div>
        <!--pdf-->
        <PDFReader v-if="resourcestype == 'pdf'" ref="PDFReader" :mode="2" @onload="onLoaded" @change="onPDFChange">
        </PDFReader>
      </div>
    </div>
  </div>
</template>

<script>
import PDFReader from '@/components/PDFReader'
// import apiCurriculum from '@/api/apiCurriculum.js'
export default {
  components: {
    PDFReader
  },
  props: {},
  data () {
    return {
      dataList: [],
      ChapterId: '', //章
      SectionId: '', //节
      resourcesID: '', //资源
      resourcestype: null //资源类型
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () {
    if (this.$route.query.ChapterId) {
      this.getCurriculum()
    } else {
      this.getCurriculum('default')
    }
  },
  beforeDestroy () {
  },
  methods: {
    //获取课程资源数据
    getCurriculum (params) {
      this.dataList = [
        {
          "chapterId": "9250fac0-fa27-4c4b-9c4c-c7707c983969",
          "chapterName": "第一章 AI金融基础入门",
          "sectionList": [
            {
              "sectionId": "8af71dff-f977-4be4-adca-1e15aacec220",
              "sectionName": "第一节 金融行业数字化转型浪潮",
              "coursewareType": "pdf",
              "is_Read": 0,
              "filepath": '/第一节 金融行业数字化转型浪潮.pdf'
            },
            {
              "sectionId": "d124f725-560d-4613-b516-7881370d888f",
              "sectionName": "第二节 AI技术核心概念剖析",
              "coursewareType": "pdf",
              "is_Read": 0,
              "filepath": '/第二节 AI技术核心概念剖析.pdf'
            },
            {
              "sectionId": "d124f725-560d-4613-b516-7881370d888d",
              "sectionName": "第三节 AI金融的发展历程与现状综述",
              "coursewareType": "pdf",
              "is_Read": 0,
              "filepath": '/第三节 AI金融的发展历程与现状综述.pdf'
            }
          ]
        },
      ]
      if (params == 'default') {
        this.SectionId = this.dataList[0].sectionList[0].sectionId
      } else {//点击节进入
        this.SectionId = this.$route.query.SectionId
      }
      this.open()
      // this.$nextTick(() => {
      //   this.$refs.PDFReader.loadFile(`/第一节 金融行业数字化转型浪潮.pdf`)
      // })
      // apiCurriculum.GetCurriculumList().then(res => {
      //   if (res) {
      //     this.dataList = res || []
      //     // 如果默认是点击开始学习进入
      //     if (params == 'default') {
      //       this.SectionId = res[0].sectionList[0].sectionId
      //     } else {//点击节进入
      //       this.SectionId = this.$route.query.SectionId
      //     }
      //     this.open()
      //   }
      // })
    },

    // 加载节资源
    open () {
      let data = {
        "f_Id": "ceefcde9-4774-47a7-ae35-32aaa48d874b",
        "f_WareName": "数字化营销的概念",
        "f_WareUrl": "",
        "f_WareUrlName": "",
        "f_FileUrl": "/file/典阅/20241230/202412301122144441.pdf",
        "f_FileName": "202412301122144441.pdf",
        "f_FileType": ".pdf",
        "f_FileSize": null,
        "f_NodeId": "8af71dff-f977-4be4-adca-1e15aacec220",
        "f_SortCode": 0,
        "f_CreatorTime": "2024-12-30 11:22:14",
        "f_CreatorUserId": null,
        "f_IsDownload": 0,
        "f_ModelName": null,
        "f_CourseName": null,
        "f_NodeName": null,
        "f_ModelId": "9250fac0-fa27-4c4b-9c4c-c7707c983969",
        "f_CourseId": "b8a45c91-1820-4e80-bb43-74a0f514f155",
        "f_OriginalFile": null,
        "f_State": 0,
        "is_Read": 0,
        "f_DeleteMark": false
      }
      this.resourcestype = data.f_FileType.replace('.', '')
      this.$nextTick(() => {
        // let sourceurl = FileUrl + data.f_FileUrl
        let sourceurl = 'http://192.168.5.8:7456' + data.f_FileUrl
        if (data.f_FileType == '.pdf') {
          // this.$refs.PDFReader.loadFile(sourceurl)
          this.$refs.PDFReader.loadFile('/第一节 金融行业数字化转型浪潮.pdf')
          this.SetResourceRecord() // 加载后添加阅读记录
        }
      })
      // apiCurriculum.GetCourseWareList({ CurrId: this.SectionId }).then(res => {
      //   if (res) {
      //     let data = res[0]
      //     this.resourcestype = data.f_FileType.replace('.', '')
      //     // this.resourcestype = 'pdf'//或pdf
      //     this.$nextTick(() => {
      //       let sourceurl = FileUrl + data.f_FileUrl
      //       if (data.f_FileType == '.pdf') {
      //         this.$refs.PDFReader.loadFile(sourceurl)
      //         this.SetResourceRecord() // 加载后添加阅读记录
      //       }
      //     })
      //   }
      // })
    },

    handleFileOpen (item, o) {
      this.chapterId = item.chapterId
      this.SectionId = o.sectionId
      this.resourcesID = o.sectionId
      // this.open()
      this.openFile(o)
    },

    openFile (data) {
      console.log(data)
      if (data.coursewareType == 'pdf') {

        this.$nextTick(() => {
          this.$refs.PDFReader.loadFile(`/${data.sectionName}.pdf`)
          this.SetResourceRecord() // 加载后添加阅读记录
        })
        // this.$refs.PDFReader.loadFile(`pdf/${data.sectionName}.pdf`)
        // this.SetResourceRecord() // 加载后添加阅读记录
      }
    },

    // 添加阅读记录
    SetResourceRecord () {
      // apiCurriculum.AddResourceRecord({
      //   'ChapterId': this.chapterId,
      //   'SectionId': this.SectionId,
      //   'resourcesID': this.resourcesID
      // })
    }
  }
}
</script>

<style scoped lang="less">
.xuexidongtai_layer {
  padding: 20px 50px;
  height: calc(100% - 40px);

  .warp {
    height: 100%;
    display: flex;

    .l-warp,
    .r-warp {
      height: 100%;
      background-color: #fff;
      border-radius: 13px;
    }

    .l-warp {
      width: 400px;
      height: calc(100% - 60px);
      margin-right: 20px;
      padding: 30px;

      .t-warp {
        width: 100%;
        height: 240px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-bottom: 1px solid #D2E7FF;

        .l-img {
          img {
            display: block;
            width: 338px;
            height: 190px;
          }
        }

        .r-info {
          flex: 1;
          color: #666666;
          margin-left: 20px;
          height: 20px;

          .r-info-name {
            font-size: 20px;
            font-weight: bold;
            margin: 10px 0 20px -10px;
          }

          .r-info-class {
            font-size: 16px;
            margin-bottom: 20px;
          }

          .r-info-jindu {
            width: 90%;
            margin-bottom: 10px;
          }

          .r-info-desc {
            margin-bottom: 20px;
          }

          .r-info-study {
            width: 3.39rem;
            height: .48rem;
            line-height: .48rem;
            background: linear-gradient(180deg, #DCE7F8 0%, #D2E2FF 100%);
            border-radius: 5px 5px 5px 5px;
            color: #182B59;
            text-align: center;
            margin: 0 auto;
            cursor: pointer;
          }
        }
      }

      .b-warp {
        margin-top: 30px;
        height: calc(100% - 270px);
        overflow: auto;

        &::-webkit-scrollbar {
          width: 3px;
        }

        .item {
          margin-bottom: 30px;

          dt {
            color: #182B59;
            font-size: 17px;
            font-weight: bold;
            margin-bottom: 14px;
          }

          dd {
            margin-bottom: 10px;
            font-size: 16px;
            white-space: nowrap;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .name-inner {
              cursor: pointer;

              &.active,
              &:hover {
                color: #006eff;
              }
            }

            .tag-pdf {
              font-size: 12px;
              color: #FF6C1B;
              background-color: #FFE8E8;
              padding: 5px;
              border-radius: 13px;
              margin-right: 10px;
            }

            .tag-video {
              font-size: 12px;
              color: #516FBB;
              background-color: #ECF1FE;
              padding: 5px;
              border-radius: 13px;
              margin-right: 10px;
            }

            .status-inner {
              font-size: 16px;
              margin-left: 20px;
            }
          }
        }
      }
    }

    .r-warp {
      width: calc(100% - 420px);
      // background-color: #000;
      padding: 15px;
      box-sizing: border-box;

      .mp4 {
        width: 100%;
        height: 100%;
      }
    }

  }
}
</style>
